import { c as _c } from "react/compiler-runtime";
import { Button } from '@/components/ui';
import { cn } from '@/lib/utils';
import { cloneElement, ReactElement } from 'react';
type IconProps = {
  size?: number;
  className?: string;
};
type OptionsSelectorElementProps = {
  name: string;
  icon: ReactElement<IconProps>;
  onClick: () => void;
  className?: string;
  active?: boolean;
  disabled?: boolean;
};
const OptionsSelectorElement = t0 => {
  const $ = _c(17);
  const {
    name,
    icon,
    onClick,
    className,
    active: t1,
    disabled: t2
  } = t0;
  const active = t1 === undefined ? false : t1;
  const disabled = t2 === undefined ? false : t2;
  const t3 = active && "hover:bg-[#FFF7ED] bg-[#FFF7ED] cursor-default";
  let t4;
  if ($[0] !== className || $[1] !== t3) {
    t4 = cn("min-w-fit flex flex-row items-center justify-center rounded-md px-2 sm:px-3 py-1.5 gap-1.5 cursor-pointer h-auto", "hover:bg-transparent hover:text-primary", "disabled:bg-white disabled:cursor-not-allowed pointer-events-auto", t3, className);
    $[0] = className;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const t5 = active ? "text-primary" : undefined;
  let t6;
  if ($[3] !== icon || $[4] !== t5) {
    t6 = cloneElement(icon, {
      size: 14,
      className: t5
    });
    $[3] = icon;
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const t7 = active && "text-primary";
  let t8;
  if ($[6] !== t7) {
    t8 = cn("font-medium text-xs sm:text-sm", t7);
    $[6] = t7;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== name || $[9] !== t8) {
    t9 = <span className={t8}>{name}</span>;
    $[8] = name;
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== disabled || $[12] !== onClick || $[13] !== t4 || $[14] !== t6 || $[15] !== t9) {
    t10 = <Button onClick={onClick} variant="ghost" className={t4} disabled={disabled}>{t6}{t9}</Button>;
    $[11] = disabled;
    $[12] = onClick;
    $[13] = t4;
    $[14] = t6;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  return t10;
};
type Option = {
  type: string;
  name: string;
  icon: ReactElement<IconProps>;
  disabled?: boolean;
};
type OptionsSelectorProps = {
  selectedOption: string | undefined;
  options: Option[];
  onClick: (type: string) => void;
  className?: string;
  elementClassName?: string;
};
const OptionsSelector = t0 => {
  const $ = _c(14);
  const {
    selectedOption,
    options,
    onClick,
    className,
    elementClassName
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("w-fit max-w-full flex flex-row flex-wrap items-center border border-[#F3F4F6] rounded-lg p-1 gap-0.5 shrink-0", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== elementClassName || $[3] !== onClick || $[4] !== options || $[5] !== selectedOption) {
    let t3;
    if ($[7] !== elementClassName || $[8] !== onClick || $[9] !== selectedOption) {
      t3 = t4 => {
        const {
          type,
          name,
          icon,
          disabled
        } = t4;
        return <OptionsSelectorElement key={type} name={name} icon={icon} active={selectedOption === type} disabled={disabled} onClick={() => onClick(type)} className={elementClassName} />;
      };
      $[7] = elementClassName;
      $[8] = onClick;
      $[9] = selectedOption;
      $[10] = t3;
    } else {
      t3 = $[10];
    }
    t2 = options.map(t3);
    $[2] = elementClassName;
    $[3] = onClick;
    $[4] = options;
    $[5] = selectedOption;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[11] !== t1 || $[12] !== t2) {
    t3 = <div className={t1}>{t2}</div>;
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
};
export type { Option };
export { OptionsSelector };